import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 ml-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-3 gap-4 w-full text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Top O' Tobago")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xl text-semibold" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Guest Registration Form")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      onclick: "javascript:print()"
    }, "[Print Form]")
  ])
], -1)
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "table-auto border divide-gray-300 w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Check-in"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Check-out"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Room type(s)"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "No. of Guests")
  ])
], -1)
const _hoisted_6 = { class: "divide-y divide-gray-200" }
const _hoisted_7 = { class: "divide-x divide-gray-200" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "w-full my-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Guest Information", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Please complete in full. This information is required by Trinidad & Tobago Tourism Office", -1)
const _hoisted_13 = { class: "table mt-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { width: "20%" }, "Booking Reference:", -1)
const _hoisted_15 = { class: "border bg-gray-100 p-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { width: "20%" }, "First name:", -1)
const _hoisted_17 = { class: "border" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { width: "20%" }, "E-mail:", -1)
const _hoisted_19 = { class: "border" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "Last name:", -1)
const _hoisted_21 = { class: "border" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "Telephone:", -1)
const _hoisted_23 = { class: "border" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Home Address & country:"),
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "border"
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Names of other guests(s):"),
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "border"
  })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Purpose of Visit:"),
  /*#__PURE__*/_createElementVNode("td", { class: "border" }),
  /*#__PURE__*/_createElementVNode("td", null, "Passport or ID#:"),
  /*#__PURE__*/_createElementVNode("td", { class: "border" })
], -1)
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"my-2\"><h3 class=\"text-lg font-semibold\">Emergency Contact</h3><table class=\"table\"><tr><td class=\"w-1/5\">First name:</td><td class=\"border\"></td><td class=\"p-1 w-1/5\">Telephone: (incl. country code)</td><td class=\"border\"></td></tr><tr><td>Last name:</td><td class=\"border\"></td><td class=\"p-1\">Other phone, email:</td><td class=\"border\"></td></tr></table></div>", 1)
const _hoisted_28 = { class: "mt-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Payment Information", -1)
const _hoisted_30 = { class: "text-lg" }
const _hoisted_31 = { style: {"text-align":"right"} }
const _hoisted_32 = { class: "table table-bordered" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th"),
  /*#__PURE__*/_createElementVNode("th", { style: {"background-color":"#ccc"} }, "Amount"),
  /*#__PURE__*/_createElementVNode("th", { style: {"background-color":"#ccc"} }, "Method")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, "Deposit paid in USD (TTD):", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "☐ Cash ☐ Credit Card ☐ Online", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, "Balance due in USD (TTD):", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "☐ Cash ☐ Credit Card ☐ Online", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xs-5" }, [
    /*#__PURE__*/_createElementVNode("h5", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Guest"),
      /*#__PURE__*/_createTextVNode(" Signature")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ______________________ ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-10" }, [
    /*#__PURE__*/_createElementVNode("h5", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Top O’ Tobago Host"),
      /*#__PURE__*/_createTextVNode(" Signature")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ______________________ ")
  ])
], -1)

import { Booking, Guest } from "api/_lib/types";
import { onMounted, Ref, ref } from "vue";
import { useRoute } from "vue-router";

type BKRef = Ref<Booking & { guest: Guest }>;


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivateGuestIntakeForm',
  setup(__props) {

let bk: BKRef = ref({}) as BKRef;
const route = useRoute();

onMounted(async () => {
  //   console.log(route.params.id);
  fetch(`/api/guestform?id=${route.params.id}`).then(async (resp: any) => {
    let { data } = await resp.json();
    bk.value = data[0];
    // console.log(bk);
    setTimeout(()=> window.print(), 1000)
   
  });
});

return (_ctx: any,_cache: any) => {
  return (_unref(bk).guest)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", _hoisted_6, [
              _createElementVNode("tr", _hoisted_7, [
                _createElementVNode("td", null, _toDisplayString(_unref(bk).checkin), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(bk).checkout), 1),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bk).roomDetails, (rd, idx) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: idx,
                      class: "capitalize"
                    }, _toDisplayString(rd.room) + ",", 1))
                  }), 128))
                ]),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bk).roomDetails, (room) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: room._key,
                      class: "capitalize"
                    }, [
                      _createTextVNode(_toDisplayString(room.room) + " : ", 1),
                      (room.noAdults)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(room.noAdults) + " adults ", 1))
                        : _createCommentVNode("", true),
                      (room.noChildren)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " & " + _toDisplayString(room.noChildren) + " children ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("tr", null, [
              _hoisted_14,
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("strong", null, _toDisplayString(_unref(bk).bookingRef), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_16,
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("strong", null, _toDisplayString(_unref(bk).guest.firstName), 1)
              ]),
              _hoisted_18,
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("strong", null, _toDisplayString(_unref(bk).guest.email), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_20,
              _createElementVNode("td", _hoisted_21, [
                _createElementVNode("strong", null, _toDisplayString(_unref(bk).guest.lastName), 1)
              ]),
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, [
                _createElementVNode("strong", null, _toDisplayString(_unref(bk).guest.phone), 1)
              ])
            ]),
            _hoisted_24,
            _hoisted_25,
            _hoisted_26
          ])
        ]),
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("h4", _hoisted_31, "Total Charge in USD (TTD): $" + _toDisplayString(_unref(bk).bookingTotalAmount.usd) + " (" + _toDisplayString(_unref(bk).bookingTotalAmount.ttd) + " TTD)", 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("tr", null, [
                _hoisted_34,
                _createElementVNode("td", null, "$" + _toDisplayString(_unref(bk).totalPaid.equivUsd), 1),
                _hoisted_35
              ]),
              _createElementVNode("tr", null, [
                _hoisted_36,
                _createElementVNode("td", null, "$" + _toDisplayString(_unref(bk).balanceDue.usd) + " (" + _toDisplayString(_unref(bk).balanceDue.ttd) + " TTD)", 1),
                _hoisted_37
              ])
            ])
          ])
        ]),
        _hoisted_38
      ]))
    : _createCommentVNode("", true)
}
}

})